import { AlignTypes } from '@monorepo-web/components-library';
import { FormatTypes, helperFormat } from '@monorepo-web/utils';
export function formatRowsFluxoCaixa(fluxo_de_ativos_caixa) {
    const rowsFluxoCaixa = fluxo_de_ativos_caixa
        ? fluxo_de_ativos_caixa.slice(1).map((row) => {
            let i = 0;
            const dataAux = row[i++];
            return {
                data: dataAux.split('-').reverse().join('/'),
                op: row[i++],
                ativo: row[i++],
                quant: helperFormat(row[i++], FormatTypes.decimals, 2),
                preco: helperFormat(row[i++], FormatTypes.decimals, 2),
                valor: helperFormat(row[i++], FormatTypes.decimals, 2),
                saldo: helperFormat(row[i++], FormatTypes.decimals, 2),
            };
        })
        : null;
    return rowsFluxoCaixa;
}
export function getColumnsFluxoCaixa() {
    const columnsFluxoCaixa = [
        {
            id: 'data',
            label: 'Data',
            freeze: true,
            align: AlignTypes.left,
        },
        {
            id: 'op',
            label: 'Operação',
            align: AlignTypes.left,
        },
        {
            id: 'ativo',
            label: 'Ativo',
            align: AlignTypes.left,
        },
        {
            id: 'quant',
            label: 'Quantidade',
            align: AlignTypes.right,
        },
        {
            id: 'preco',
            label: 'Preço do Ativo',
            align: AlignTypes.right,
        },
        {
            id: 'valor',
            label: 'Valor Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'saldo',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
    ];
    return columnsFluxoCaixa;
}
